export default __webpack_public_path__ + "static/media/iphone-pink.b5461543.png";